import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../utilities/config";
const { Auth, Storage } = require("aws-amplify");

const SignIn = async (password, username, navigate) => {
  try {
    console.log(password, username);
    const authUser = await Auth.signIn(username, password);
    localStorage.setItem("user", JSON.stringify(authUser.attributes));
    toast.success("Successfully login");
    navigate("../");
    return true;
  } catch (error) {
    toast.error(error.message);
    if (error.code == "UserNotConfirmedException") {
      try {
        await Auth.resendSignUp(username);
      } catch (error) {
        console.log(error.message);
      }
      navigate("../pass-code", {
        state: { username: username, type: "verify" },
      });
    }
    return false;
  }
};

const Register = async (password, username, name, navigate) => {
  try {
    console.log(password, username, name);
    const authUser = await Auth.signUp({
      username,
      password,
      attributes: {
        name, // optional
      },
      autoSignIn: {
        // optional - enables auto sign in after user is confirmed
        enabled: true,
      },
    });
    toast.success("Successfully Registered");
    localStorage.setItem("user", JSON.stringify(authUser.attributes));
    navigate("../pass-code", {
      state: { username: username, type: "verifyreg" },
    });
    return true;
  } catch (error) {
    toast.error(error.message);
    return false;
  }
};

const ResendCode = async (username, setShow) => {
  try {
    setShow(false);
    await Auth.resendSignUp(username);
  } catch (error) {
    toast.error(error.message);
  }
  setShow(true);
};

const ConfirmCode = async (username, code, setLoad, navigate, type) => {
  try {
    if (!code) {
      toast.error("Invalid Code");
      return;
    }
    setLoad(true);
    const authUser = await Auth.confirmSignUp(username, code);
    if (authUser) {
      toast.success("Verified Successfully");
      if (type == "verify") {
        navigate("../");
      } else if (type == "verifyreg") {
        navigate("../login");
      }
    }
  } catch (error) {
    console.log(error.code);
    toast.error(error.message);
  }
  setLoad(false);
};

const Logout = async (navigate) => {
  try {
    await Auth.signOut();
    localStorage.clear();
    navigate("../login");
  } catch (error) {
    console.log(error.code);
    toast.error(error.message);
  }
};

const GetUserData = async (navigate) => {
  try {
    let User = localStorage.getItem("user");
    if (User) {
      return User;
    } else {
      navigate("../login");
    }
  } catch (error) {
    navigate("../login");
  }
};

const ForgPassword = async (username, navigate) => {
  try {
    const authUser = await Auth.forgotPassword(username);
    navigate("../change-password", {
      state: { username: username, type: "forgotpass" },
    });
    return true;
  } catch (error) {
    toast.error(error.message);
    return false;
  }
};

const ForgPasswordSubmit = async (username, code, password, navigate) => {
  try {
    console.log(code);
    const authUser = await Auth.forgotPasswordSubmit(username, code, password);
    toast.success("Password changed successfully");
    navigate("../login");
    return true;
  } catch (error) {
    toast.error(error.message);
    return false;
  }
};

const ChangePasswordM = async (oldPass, newPass, setShow) => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const authUser = await Auth.changePassword(user, oldPass, newPass);
    toast.success("Password changed successfully");
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
};

const ChangeDetails = async (name, email, setShow) => {
  try {
    let user = await Auth.currentAuthenticatedUser();
    const authUser = await Auth.updateUserAttributes(user, {
      email: email,
      name: name,
    });
    user = await Auth.currentAuthenticatedUser();
    localStorage.setItem("user", JSON.stringify(user.attributes));
    toast.success("Details changed successfully");
    setShow(false);
  } catch (error) {
    toast.error(error.message);
  }
};

const uploadImg = async (e) => {
  const file = e;
  try {
    const upldImg = await Storage.put(file.name, file, {
      contentType: "image/png", // contentType is optional
    });
    let user = await Auth.currentAuthenticatedUser();
    const authUser = await Auth.updateUserAttributes(user, {
      profile: upldImg.key,
    });
    user = await Auth.currentAuthenticatedUser();
    localStorage.setItem("user", JSON.stringify(user.attributes));
    toast.success("Image updated successfully");
    console.log(upldImg);
    return upldImg;
  } catch (error) {
    toast.error(error.message);
  }
};

const getFile = async (name) => {
  const file = await Storage.get(name, {
    level: "public",
  });
  return file;
};


async function defaultApiCallPost(path,payload) {
  try {
    let User = await localStorage.getItem("user");
    if(User){
    User = JSON.parse(User)
    let {sub} = User;
    console.log(sub)
    payload.user_id = sub;
    let data = await axios.post(`${API_URL}/${path}`,payload,{
      headers:{
        contentType:"application/json"
      }
    });
      return data;
    }
    else{
      return false
    }
  } catch (error) {
    console.log(error);
    return false;
  }
}


async function fetchLegalDiscoveryDashboard(){
  let payload = {
    user_id: 0
  }
  let usData = await defaultApiCallPost("fetchLegalDiscoveryDashboard",payload);
  return usData
}





export {
  SignIn,
  Register,
  ResendCode,
  ConfirmCode,
  Logout,
  GetUserData,
  ForgPassword,
  ForgPasswordSubmit,
  ChangePasswordM,
  ChangeDetails,
  uploadImg,
  getFile,
  fetchLegalDiscoveryDashboard
};
